export enum Toast {
  NetError = 'NetError',
  LoginExpiration = 'LoginExpiration',
}
